//medidad Banner 650x360px
export const ultimasNoticias = [

   {
        "imagen" :"../assets/imgs/UltimasNoticias/MCine.png",
        "url" : "https://taquilla.cecultah.gob.mx/events/muestra-internacional-de-cine-2025-julio-agosto/",
        "titulo" : "Muestra Internacional de Cine 2025",
        "fecha" : "22 de julio al 02 de agosto del 2025"
    },

   {
        "imagen" :"../assets/imgs/UltimasNoticias/AyR2.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Resultados Programa de Desarrollo Cultural Infantil Alas y Raíces Hidalgo 2025 segunda ronda.pdf",
        "titulo" : "Resultados del Programa de Desarrollo Cultural Infantil Alas y Raíces Hidalgo 2025 Segunda Etapa",
        "fecha" : "18 de junio del 2025"
    },
    
   {
        "imagen" :"../assets/imgs/UltimasNoticias/AyR1.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Resultados Programa de Desarrollo Cultural Infantil Alas y Raíces Hidalgo 2025 primera ronda.pdf",
        "titulo" : "Resultados del Programa de Desarrollo Cultural Infantil Alas y Raíces Hidalgo 2025 Primer Etapa",
        "fecha" : "19 de Mayo del 2025"
    },
    
]